import type { PageviewNode } from '../types';
import { extractFilters, toNumber, toString } from './parse-helpers';

/**
 * Parse pageview conditions.
 * Handles: { event: { type: 'page', name, filters }, times, within, inverse }
 *          { type: 'pageview', url, times, within, inverse }
 */
export function parsePageview(raw: Record<string, unknown>): PageviewNode | null {
  const event = raw.event as Record<string, unknown> | undefined;
  if (event?.type === 'page' || event?.type === 'pageview') {
    const name = toString(event.name);
    const url = name !== '*' ? name : undefined;
    const parsed = extractFilters(event.filters);
    const eventFilter = raw.event_filter as Record<string, unknown> | undefined;
    return {
      type: 'pageview',
      url,
      inverse: (eventFilter?.inverse ?? raw.inverse) === true,
      times: toNumber(eventFilter?.times ?? raw.times),
      within: toNumber(eventFilter?.within ?? raw.within),
      filters: parsed?.filters,
      filtersOperator: parsed?.operator,
    };
  }

  if (raw.type === 'pageview') {
    const name = toString(raw.url ?? raw.name);
    const url = name !== '*' ? name : undefined;
    const parsed = extractFilters(raw.filters);
    return {
      type: 'pageview',
      url,
      inverse: raw.inverse === true,
      times: toNumber(raw.times),
      within: toNumber(raw.within),
      filters: parsed?.filters,
      filtersOperator: parsed?.operator,
    };
  }

  return null;
}
